export const LOGIN_SUCCESS = "Logged in successfully!"
export const LOGOUT_SUCCESS = "Logged out successfully!"
export const REGISTER_SUCCESS = "Registration successful"
export const RESET_PASS_SUCCESS = "Password reset successfully!"
export const ADDED_CARD_SUCCESS = "Added card successfully!"
export const ORDER_CONFIRM = "Order confirmed successfully!"
export const PICKUP_CONFIRM = "Order collected successfully!"
